import { createFileRoute } from '@tanstack/react-router';
import { Header, Footer } from '@/components/marketing';
import { Badge } from '@/components/ui/badge';

export const Route = createFileRoute('/privacy')({
  component: PrivacyPage,
});

function PrivacyPage() {
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main className="flex-1 pt-24 pb-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
          <div className="text-center mb-12">
            <Badge variant="secondary" className="mb-4">Legal</Badge>
            <h1 className="text-4xl font-bold tracking-tight sm:text-5xl mb-4">Privacy Policy</h1>
            <p className="text-muted-foreground">Last updated: December 4, 2024</p>
          </div>
          <div className="prose prose-neutral dark:prose-invert max-w-none">
            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">1. Information We Collect</h2>
              <p className="text-muted-foreground mb-4">
                We collect information you provide directly when you create an account, upload repositories, or contact us. This includes your email address, name, and any code or documentation you choose to analyze.
              </p>
              <p className="text-muted-foreground">
                We also automatically collect certain technical information such as your IP address, browser type, and usage patterns to improve our services.
              </p>
            </section>
            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">2. How We Use Your Information</h2>
              <p className="text-muted-foreground mb-4">We use your information to:</p>
              <ul className="list-disc pl-6 text-muted-foreground space-y-2">
                <li>Provide and maintain our code analysis services</li>
                <li>Process your repository uploads and generate analysis reports</li>
                <li>Send you important updates about your account and our services</li>
                <li>Improve and develop new features</li>
                <li>Ensure the security and integrity of our platform</li>
              </ul>
            </section>
            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">3. Code and Repository Data</h2>
              <p className="text-muted-foreground mb-4">
                Your uploaded code is processed securely and is never shared with third parties. We do not use your proprietary code to train machine learning models. Analysis results are stored in your private workspace and accessible only to you and authorized team members.
              </p>
            </section>
            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">4. Data Security</h2>
              <p className="text-muted-foreground mb-4">
                We implement industry-standard security measures including encryption at rest and in transit, regular security audits, and strict access controls to protect your data.
              </p>
            </section>
            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">5. Data Retention</h2>
              <p className="text-muted-foreground mb-4">
                We retain your data for as long as your account is active. You can request deletion of your data at any time by contacting our support team or through your account settings.
              </p>
            </section>
            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">6. Your Rights</h2>
              <p className="text-muted-foreground mb-4">
                You have the right to access, correct, or delete your personal information. You may also request a copy of your data in a portable format. Contact us at privacy@forgenetwork.pro to exercise these rights.
              </p>
            </section>
            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">7. Contact Us</h2>
              <p className="text-muted-foreground">
                If you have questions about this Privacy Policy, please contact us at privacy@forgenetwork.pro.
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
